import { Button, HStack, Text } from "@chakra-ui/react";
import { t } from "i18next";
import { useStores } from "../../../../shared/stores/RootStore";

export const ForecastHeader = () => {
  const { craForecastStore, hlaForecastStore } = useStores();

  if (
    !craForecastStore.isForecastModeActivated() &&
    !hlaForecastStore.isForecastModeActivated()
  ) {
    return null;
  }

  return (
    <HStack
      p={2}
      fontSize="sm"
      bgColor="primary.100"
      justifyContent="center"
      gap={4}
    >
      <Text>{t("map:forecast.header.text")}</Text>
      <Button
        variant="outline"
        size="xs"
        colorPalette="primary"
        onClick={() => {
          craForecastStore.restoreOriginal();
          hlaForecastStore.restoreOriginal();
        }}
      >
        {t("map:forecast.header.resetBtn")}
      </Button>
    </HStack>
  );
};
